<template>
  <v-container class="v-container">
    <v-layout>
      <v-flex xs12 sm10 md5 lg5>
        <div class="page-title">Reset Password</div>
        <div class="registration-form">
        <v-form @submit.prevent="submit()">
          <v-layout column class="login-layout">
            <input
              v-model="form.password"
              :class="{ 'wrong-input': $v.form.password.$invalid && showErrors }"
              type="password"
              placeholder="New Password"
              id="pass"
              class="custom-input"
            />
            <input
              v-model="form.repeatPassword"
              :class="{ 'wrong-input': $v.form.repeatPassword.$invalid && showErrors }"
              type="password"
              placeholder="Repeat New Password"
              id="repeatPass"
              class="custom-input"
            />
            <p v-if="showErrors" class="error-message">
              <span v-if="!$v.form.password.required">New Password is required.</span>
              <span v-if="!$v.form.password.minLength"
                >New Password must have at least
                {{ $v.form.password.$params.minLength.min }} letters.</span
              >
              <span v-if="!$v.form.repeatPassword.sameAsPassword"
                >Repeat New Passwords must be identical.</span
              >
            </p>
            <v-flex xs12 sm12 md12 class="submit-button-container">
              <button class="submit-button" type="submit" id="submit-registration">Submit</button>
            </v-flex>
            <router-link :to="{ name: 'login' }"
              ><div class="registration"><span>Login</span></div></router-link
            >
          </v-layout>
        </v-form>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AuthorizService from '@/services/AuthorizService';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
export default {
  name: 'ResetPassword',
  data() {
    return {
      showErrors: false,
      token: '',
      form: {
        password: '',
        repeatPassword: '',
      },
    };
  },
  created() {
    if (this.$route.query.token) {
      this.token = this.$route.query.token;
    }
  },
  methods: {
    ...mapActions(['setLoading', 'showSnackbar']),
    submit() {
      this.showErrors = false;
      if (!this.$v.$invalid) {
        this.setLoading({ show: true, text: 'Reseting...' });
        const jsonToSend = {
          password: this.form.password,
          token: this.token,
        };
        AuthorizService.resetNewPassword(jsonToSend)
          .then(() => {
            this.setLoading({ show: false, text: '' });
            this.showSnackbar('Your password has been changed successfully!');
            this.$router.push({ name: 'login' });
          })
          .catch((err) => {
            this.setLoading({ show: false, text: '' });
            if (err.response.status === 404) {
              this.showSnackbar('Bad token!');
            } else if (err.response.status === 500) {
              this.showSnackbar(err.response.data);
            } else {
              this.showSnackbar(
                'Something wrong. Your password has not been changed successfully! Try again!'
              );
            }
          });
      } else {
        this.showErrors = true;
      }
    },
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(4),
      },
      repeatPassword: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
};
</script>

<style scoped>
.submit-button-container {
  margin-top: 30px;
}
.v-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 100%;
  justify-content: center;
  align-items: center;
}
.user-form {
  margin: auto;
}
.submit-button {
  margin-top: 0;
}
.registration-form {
  position: relative;
  -webkit-box-shadow: 0 3px 10px 1px rgba(18, 13, 10, 0.13);
  box-shadow: 0 3px 10px 1px rgba(18, 13, 10, 0.13);
  background-color: #ffffff;
  margin-right: auto;
  margin-left: auto;
  padding: 46px 35px;
}

.error-message {
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  color: #fd6262;
}

.error-message span {
  display: block;
}

.wrong-input {
  outline: 2px solid #fd6262 !important;
}

.registration-form {
  max-width: 450px;
}
.registration {
  
  margin-top: 14px;
  color: #216169;
  display: flex;
  font-size: 12px;
  cursor: pointer;
  font-weight: 400;
  flex-direction: row;
  justify-content: center;
  text-decoration: underline;
}
.custom-input {
  background-position-y: center;
  background-position-x: 10px;
  width: 100%;
  height: 46px;
  color: #216169;
  background-color: #c4c4c44d;
  font-size: 12px;
  margin-bottom: 17px;
  padding: 10px 10px 10px 50px;
}
.custom-input[type='text'] {
  background-repeat: no-repeat;
  background-image: url('../assets/user.png');
}
.custom-input[type='email'] {
  background-repeat: no-repeat;
  background-image: url('../assets/Vector_Smart_Object(1).png');
}
.custom-input[type='password'] {
  background-repeat: no-repeat;
  background-image: url('../assets/password.png');
}
</style>
